import { render, staticRenderFns } from "./cookies.vue?vue&type=template&id=58a6b014"
import script from "./cookies.vue?vue&type=script&lang=js"
export * from "./cookies.vue?vue&type=script&lang=js"
import style0 from "./cookies.vue?vue&type=style&index=0&id=58a6b014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports